import * as config from '../../../config';
export const googleRecaptchaConfig = {
    sitekey: config.RECAPTCHA_SITE_KEY,
    locale: config.LOCALE
};
export const ALLOWED_FIELDS_CONTACT_DATA = [
    'email',
    'locale',
    'firstName',
    'lastName',
    'company',
    'gender',
    'jobTitle',
    'subscribeRecaptchaToken',
    'otherEmails',
    'streetName',
    'postalCode',
    'city',
    'countryCode',
    'phone',
    'otherPhones',
    'faxes',
    'meta',
    'category',
    'distributionList',
    'supportedDist'
];
